import React, { useRef, useEffect } from 'react';

export function MessageExamples() {
  const scrollRef = useRef(null);

  const examples = [
    "Bitte spiele Titanium von David Guetta",
    "Was ist dein Hobby?",
    "Erzähl mir einen Fakt über dich",
    "Grüße aus Hamburg!",
    "Wie war dein Wochenende?",
    "Kannst du Paradise von Coldplay spielen?",
    "Welches Buch liest du gerade?",
    "Viel Erfolg bei der Show heute!",
    "Hast du Tipps für gute Podcasts?",
    "Spiel mehr elektronische Musik!",
    "Was ist deine Lieblingsband?",
    "Schöne Grüße an Chris & Lena!"
  ];

  // Auto-scroll effect - constant speed
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.5; // Constant speed

    const scroll = () => {
      scrollPosition += scrollSpeed;

      // Reset when scrolled past one third (for seamless infinite effect with triple examples)
      if (scrollPosition >= container.scrollWidth / 3) {
        scrollPosition = 0;
      }

      container.scrollLeft = scrollPosition;
      requestAnimationFrame(scroll);
    };

    requestAnimationFrame(scroll);

    return () => {
      // Cleanup handled by component unmount
    };
  }, []);

  return (
    <div className="w-full mt-12">
      <h3 className="text-center text-white/80 text-sm sm:text-base md:text-lg lg:text-xl mb-6">
        Hier sind ein paar Beispiele
      </h3>

      {/* Scrolling container with fade edges */}
      <div className="relative">
        {/* Left fade - dark background matching page */}
        <div
          className="absolute left-0 top-0 bottom-0 w-32 pointer-events-none z-10"
          style={{
            background: 'linear-gradient(to right, rgb(15, 10, 26) 0%, rgba(15, 10, 26, 0) 100%)'
          }}
        />

        {/* Right fade - dark background matching page */}
        <div
          className="absolute right-0 top-0 bottom-0 w-32 pointer-events-none z-10"
          style={{
            background: 'linear-gradient(to left, rgb(15, 10, 26) 0%, rgba(15, 10, 26, 0) 100%)'
          }}
        />

        {/* Scrolling container */}
        <div
          ref={scrollRef}
          className="overflow-x-hidden whitespace-nowrap scrollbar-hide py-2"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
        {/* Triple examples for seamless infinite scroll effect */}
        <div className="inline-flex gap-4">
          {[...examples, ...examples, ...examples].map((example, index) => (
            <div
              key={index}
              className="inline-block px-6 py-4 rounded-2xl bg-white transition-all duration-300 hover:scale-105"
            >
              <p className="text-gray-800 text-sm font-light" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {example}
              </p>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  );
}
